import { render, staticRenderFns } from "./UkrTreasuresEditing.vue?vue&type=template&id=008d7612&scoped=true"
import script from "./UkrTreasuresEditing.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d7612",
  null
  
)

export default component.exports